module.exports = __webpack_public_path__ + "media/images/3img-fd66334692660ffd1b676c079d17d472.jpg";